const editedTasksStorageKey = "editedTasks";
export const loadEditedTasks = () => {
  try {
    const serializedState = localStorage.getItem(editedTasksStorageKey);
    if (serializedState === null) {
      return [];
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const storeEditedTasks = (_oldEditedReviewTasks, newEditedReviewTasks) => {
  const redactedData = newEditedReviewTasks.map(({ reviewId, reviewTaskId, action, comment,reviewedBy,decisionReason, reviewedAt }) => ({
    reviewId,
    reviewTaskId,
    action,
    comment,
    reviewedBy,
    reviewedAt,
    decisionReason
  }));
  try {
    const serializesState = JSON.stringify(redactedData);
    localStorage.setItem(editedTasksStorageKey, serializesState);
  } catch (err) {
    console.error(err);
  }
};
